import { render, staticRenderFns } from "./courseEvaluation.vue?vue&type=template&id=1cff88ff&scoped=true&"
import script from "./courseEvaluation.vue?vue&type=script&lang=ts&"
export * from "./courseEvaluation.vue?vue&type=script&lang=ts&"
import style0 from "./courseEvaluation.vue?vue&type=style&index=0&id=1cff88ff&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cff88ff",
  null
  
)

export default component.exports